import { render } from "./Loading.vue?vue&type=template&id=4486efb8"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v3/Loading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4486efb8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4486efb8', __exports__)) {
    api.reload('4486efb8', __exports__)
  }
  
  module.hot.accept("./Loading.vue?vue&type=template&id=4486efb8", () => {
    api.rerender('4486efb8', render)
  })

}


export default __exports__